<template>
  <div class="journeyInformation">
    <Nav :title="title"></Nav>
    <div class="loading" v-if="isLoad" :style="{ height: winHeight + 'px' }">
      <img src="./../../assets/takingCar/loading.gif" alt="" />
    </div>
    <div class="content" :class="{ isIosx: isiOSX }" v-if="!isLoad">
      <div class="in">
        <div class="list" v-for="(item, index) in list" :key="index">
          <p class="tip">{{ item.date }}</p>
          <div class="in initem" v-for="(i, j) in item.list" :key="j">
            <p class="title">
              {{ i.platform.platform_name.substring(0, 2)
              }}{{ i.car_type_name }}
              <span>{{ i.created_at | timeFormat }}</span>
              <span class="airport" v-if="i.type == 3 || i.type == 4">接送机</span>
            </p>
            <p class="cfd">
              <img src="./../../assets/takingCar/qsd.png" alt />
              <span>{{ i.start_position }}</span>
            </p>
            <p class="mdd">
              <span class="mddp">
                <img src="./../../assets/takingCar/zd.png" alt />
                <span>{{ i.end_address }}</span>
              </span>

              <span class="money">
                {{ i.external_total_money | moneyFormat }}
                <span>元</span>
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "./nav";
export default {
  data() {
    return {
      title: "发票行程信息",
      isiOSX: false,
      list: [],
      external_order_sn_s: "",
      isLoad: true,
      winHeight: "0",
    };
  },
  filters: {
    timeFormat(str) {
      var mydate = new Date(str.replace(/-/g, "/"));
      var myddy = mydate.getDay(); //获取存储当前日期
      var weekday = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      return (
        str.substring(0, 10) +
        " " +
        weekday[myddy] +
        " " +
        str.substring(10, 16)
      );
    },
    moneyFormat(value) {
      var value = Math.round(parseFloat(value) * 100) / 100;
      var xsd = value.toString().split(".");
      if (xsd.length == 1) {
        value = value.toString() + ".00";
        return value;
      }
      if (xsd.length > 1) {
        if (xsd[1].length < 2) {
          value = value.toString() + "0";
        }
        return value;
      }
    },
  },
  components: { Nav },
  created() {
    this.isiOSX = this.isIphoneX();
    this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    this.external_order_sn_s = this.$route.query.external_order_sn_s;
    this.getInformationData();
    this.winHeight = document.documentElement.clientHeight; //浏览器视口大小
  },
  methods: {
    // 获取发票行程信息
    getInformationData() {
      this.$api
        .post("/taxis/member/invoice/history/trip/detail", {
          external_order_sn_s: this.external_order_sn_s,
        })
        .then((res) => {
          this.isLoad = false;
          // console.log(res);
          this.list = res;
        });
    },
  },
  mounted() {},
};
</script>

<style lang="less">
.journeyInformation {
  background: #f5f6f7;
  min-height: 100%;
  .loading {
    width: 40%;
    margin: 0 auto;
    display: flex;
    height: 100%;
    img {
      width: 100%;
      align-self: center;
    }
  }
  .content {
    margin: 0px 15px 0;
    padding-top: 70px;
    padding-bottom: 20px;
    .list {
      .tip {
        font-size: 13px;
        line-height: 18px;
        color: #999999;
        margin: 20px 0 0;
      }
      .in {
        padding: 1px 15px;
        background-color: #ffffff;
        border-radius: 5px;
        font-size: 13px;
        line-height: 18px;
        margin-top: 20px;
        .title {
          color: #333333;
          font-size: 15px;
          margin: 15px 0;
          line-height: 21px;
          font-weight: bold;
          span {
            color: #666666;
            font-size: 13px;
            line-height: 18px;
            margin-left: 14px;
            font-weight: normal;
          }
          .airport {
            display: inline-block;
            width: 60px;
            height: 24px;
            line-height: 24px;
            text-align: center;
            background: url("./../../assets/takingCar/airport.png") no-repeat 0
              0;
            background-size: 100%;
            margin-left: 10px;
            font-size: 12px;
            font-weight: 400;
            color: #ff5700;
          }
        }
        p {
          color: #333333;
          font-size: 13px;
          line-height: 18px;
          img {
            width: 11px;
            height: 11px;
            margin: 0 10px 0 0px;
          }
        }
        .cfd {
          display: flex;
          align-items: center;
          span {
            flex: 1;
          }
        }
        .mdd {
          margin: 10px 0;
          overflow: hidden;
          position: relative;
          display: flex;
          .mddp {
            flex: 1;
            display: flex;
            align-items: center;
            span {
              flex: 1;
            }
          }
          span {
            font-size: 14px;
            line-height: 28px;
          }
          .money {
            font-size: 20px;
            line-height: 18px;
            font-weight: bold;
            span {
              font-weight: normal;
            }
          }
        }
      }
    }
  }
  .isIosx {
    padding-top: 90px;
  }
}
</style>
